var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "journey-connection-property-base",
    {
      attrs: {
        label: _vm.resource("JourneyBuilder_DeduplicationSettings_FieldName"),
        "for-input": _vm.id
      }
    },
    [
      _c(
        "v-select",
        {
          staticClass: "form-control",
          attrs: {
            id: _vm.id,
            options: _vm.options,
            disabled: !_vm.canWrite || !_vm.isActive,
            searchable: "",
            filterable: ""
          },
          model: {
            value: _vm.model,
            callback: function($$v) {
              _vm.model = $$v
            },
            expression: "model"
          }
        },
        [_c("div", { attrs: { slot: "no-options" }, slot: "no-options" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }